import styles from './ToDownload2.module.scss'

export interface ToDownload2Props {
  imgSrc: string
  alt: string
  title: string
  description: string
  link: string
  subText?: string
  className?: string
}

const ToDownload2: React.FC<ToDownload2Props> = ({
  imgSrc,
  alt,
  title,
  description,
  link,
  subText = 'サービス資料',
  className = '',
}) => {
  return (
    <div className={`${styles.toDownload} ${className}`}>
      <a href={link} className={styles.toDownload__link}>
        <figure className={styles.toDownload__link__image}>
          <img src={imgSrc} alt={alt} width={280} height={157} />
        </figure>
        <div className={styles.toDownload__link__cts}>
          <p className={styles.toDownload__link__cts__sub}>{subText}</p>
          <dl className={styles.toDownload__link__cts__item}>
            <dt className={styles.toDownload__link__cts__item__title}>{title}</dt>
            <dd className={styles.toDownload__link__cts__item__text}>{description}</dd>
          </dl>
        </div>
      </a>
    </div>
  )
}

export default ToDownload2
